import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import { useTranslation } from '../../contexts/TranslationContext';

const Layout = ({ children, showHeader = true, showFooter = true, ...props }) => {
  const { isRTL, getDirectionClass } = useTranslation();

  return (
    <Box 
      minHeight="100vh" 
      direction={isRTL() ? 'rtl' : 'ltr'}
      className={getDirectionClass('layout-container')}
      {...props}
    >
      <Flex direction="column" minHeight="100vh">
        {showHeader && <Header />}
        
        <Box flex="1" as="main" className="main-content">
          {children}
        </Box>
        
        {showFooter && <Footer />}
      </Flex>
    </Box>
  );
};

export default Layout;

